export const getFocusableElements = (
    hostElement: HTMLElement
): NodeListOf<HTMLElement> => {
    return hostElement.shadowRoot!.querySelectorAll(
        'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]),' +
            '[tabindex]:not([disabled]):not([tabindex="-1"])'
    );
};
